import { React, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Banner from '../Components/Banner';
// import banner from '../images/banner_image.jpg'
import banner_image_liaisonservice from '../images/banner_images/laptop/liaison.png'
import mobliaisonbanner from '../images/banner_images/mobile/mobile_liasonbanner.png'
import card_image_1 from '../images/liaison/building_planapproval.png'
import card_image_2 from '../images/liaison/landuse_change.png'
import card_image_3 from '../images/liaison/layout_approval.png'
import card_image_4 from '../images/liaison/haka_noc.png'
import google_logo from '../images/liaison/Google-Review-Logo 1.png'
import liaison_brochure from "../images/brochures/liaison_brochure.pdf"
// components
import LiaisonServiceCard from '../Card-Components/liaison_Services_card'
import Milestones from '../Card-Components/milestones'
import Whyus from '../Card-Components/Whyus'
import ChatWithus from '../Components/chatwithus'
import OtherServices from "../Card-Components/Other_Services";
import Testimonial from "../Components/Testimonial";
import FAQ from "../Components/FAQ/FAQ"
import TestimonialSlider from '../Components/testimonial_slider';
import Button from '../Components/Button';


function LiaisonService() {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const serviceCard = [
        {
            heading: 'Building Plan',
            subheading: 'Approval',
            src: card_image_1,
            alt: "Building plan Approval",
            content: "End-to-end approval management, fully compliant.",
            micro_id: "dtcp",

        },
        {
            heading: 'Land Use ',
            subheading: 'Change',
            src: card_image_2,
            alt: "Land Use Change",
            content: "Residential, commercial, or industrial — we handle all the formalities.",
            micro_id: "landuse"

        },
        {
            heading: 'Layout',
            subheading: 'Approval',
            src: card_image_3,
            alt: "Layout Approval",
            content: "Complete support to secure statutory layout approvals.",
            micro_id: "layoutapproval",
        },
        {
            heading: 'HACA',
            subheading: 'NOC',
            src: card_image_4,
            alt: "HAKA Noc",
            content: "Simplified approvals for hill area projects.",
            micro_id: "hacanoc",
        },

    ]

    const handleTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };



    return (
        <>
            <Banner
                img={banner_image_liaisonservice}
                mimg={mobliaisonbanner}
                alt="Banner-Image"
                heading="Personally invested in every relationship"
                subheading="SIMPLIFYING APPROVALS & LICENSING"
                textposition={"w-[85%] bottom-8 left-8 right-8 lg:w-[675px] lg:bottom-[100px] lg:left-[100px]"}
                renderButton={() => (
                    <Button name={"Get Started"} design={"filled"} action={"scroll"} section_id={"liaison-services"} />
                )}
            />

            {/*Liasion Serive */}
            <div className="max-w-[900px] mx-auto px-6 my-[100px] text-center">
                <h2 className="heading" data-aos="fade-up">Real<span className="font-[timesnewroman]">-</span>Estate Liaison Service</h2>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800"/>
                <p className="service-description" data-aos="fade-up" data-aos-duration="1100">Buying, selling, developing, or leasing property in Tamil Nadu? Our liaison team streamlines approvals, clearances, and compliance across all government departments. From paperwork to permits, we handle the details so your project stays on track.</p>
            </div>

            <div className="max-w-7xl mx-auto flex flex-wrap justify-between gap-y-20 my-10 sm:my-20" data-aos="fade-up">
                {
                    serviceCard.map((items) => {
                        return (

                            <div className="max-w-[294px] mx-auto bg-card-grey h-[542px] relative" data-aos="fade-up" data-aos-duration="500" data-aos-anchor-placement="top-bottom">
                                <img className="w-full" src={items.src} alt={items.alt} />

                                <div className='max-w-[320px] text-center py-[35px] px-6'>
                                    <h1 className="max-w-[195px] mx-auto my-auto font-noto font-bold text-[28px] leading-[40px]">{items.heading}<br /><span>{items.subheading}</span></h1>
                                    <p className='font-alibaba text-[18px] leading-[26px] text-[#5F5D5E] mt-[20px] max-w-[250px]'>{items.content}</p>

                                    <div className='absolute m-auto left-0 right-0 bottom-[40px]'>
                                        <Button
                                            name={"Explore now"}
                                            design={"unfilled"}
                                            action={"internal-linking"}
                                            pageLink={"/liaison/" + items.micro_id}
                                        />
                                    </div>

                                </div>

                            </div>

                        );
                    })}
            </div>

            <LiaisonServiceCard />


            {/* Milestones */}
            <Milestones />




            {/* <OtherServices /> */}

            <FAQ />

            <TestimonialSlider />


            <a href='www.google.com'>
                <div className='flex-col justify-center text-center'>
                    <img className='w-[168px] mx-auto' src={google_logo} alt='Google_logo'  data-aos="fade-up"/>
                    <p className='text-[18px] text-[#575857] mt-[10px]' data-aos="fade-up">Check out our Google reviews page <span className='text-[#FF0000]'> here.</span></p>
                </div>
            </a>

            {/* Chat with us  */}
            <ChatWithus />

        </>
    )
}

export default LiaisonService;